<script>
import Layout from '@/views/layouts/main';
import Footer from '@/components/Footer/main.vue';
import appConfig from '@/app.config';
import i18n from '@/i18n';
import LoadingIcon from '@/components/Loading/main.vue';
import UploadFileCommon from '@/components/Uploads/Files/main.vue';

import { campaignMethods, manualService } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';
import { handleDownFile } from '@/utils/format';

export default {
    page: {
        title: i18n.t('manual.title'),
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        LoadingIcon,
        UploadFileCommon,
        Footer
    },
    data() {
        return {
            isLoading: false,
            initForm: {
                company_name: '',
                main_office: '',
                url: '',
                date_created: '',
                configDateCreated: {
                    error: false,
                    errorDateCreated: ''
                },
                capital: '',
                business_content: '',
                center_office: '',
                chief_executive_officer: '',
                number_of_employees: '',
                organizational_structure: '',
                certification: '',
                technical_safety: '',
                organizational_security_management: '',
                physical_security_management: '',
                human_security_management: '',
                logo: {
                    id: null,
                    path: ''
                }
            },
            isUploadFile: false
        };
    },

    mounted() {
        this.getDetail();
    },
    methods: {
        checkPermission,
        ...campaignMethods,
        ...manualService,

        checkPermiss(listRole) {
            return checkPermission(listRole);
        },

        handleSubmit() {
            let dataObject = Object.assign({}, this.initForm);
            delete dataObject.configDateCreated;
            if (!dataObject.logo?.id) {
                dataObject.logo = {
                    id: null
                };
            }

            dataObject.code = 1;
            this.isLoading = true;
            this.updateManual(dataObject)
                .then((res) => {
                    this.isLoading = false;
                    if (res.code !== 200) {
                        showMessage(res.code, this.$bvToast, res.message);
                        return;
                    }
                    showMessage(res.code, this.$bvToast, '登録されました。');
                    this.getDetail();
                })
                .catch((error) => {
                    console.log('error', error);
                    this.isLoading = false;
                });
        },

        getDetail() {
            this.isLoading = true;
            let code = 1;
            this.detailManual(code)
                .then((res) => {
                    this.initForm = {
                        ...this.initForm,
                        ...res
                    };
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log('error', error);
                    this.isLoading = false;
                });
        },

        downLoadFile(path, name) {
            if (path) return handleDownFile(path, name);
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="!isLoading">
            <h4 class="ml-2">{{ $t('manual.overview') }}</h4>
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <form class="needs-validation" @submit.prevent="handleSubmit" autocomplete="off">
                            <h5 class="mb-5">{{ $t('manual.titleForm1') }}</h5>
                            <div class="form-group row">
                                <label class="col-sm-2" for="nameCompany">{{ $t('manual.nameCompany') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.company_name" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="mainOffice">{{ $t('manual.mainOffice') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.main_office" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="url">{{ $t('manual.url') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.url" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="dateCreated">{{ $t('manual.dateCreated') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.date_created" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="capital">{{ $t('manual.capital') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.capital" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="businessContent">{{ $t('manual.businessContent') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.business_content" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="centerOffice">{{ $t('manual.centerOffice') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.center_office" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="chiefExecutiveOfficer">{{ $t('manual.chiefExecutiveOfficer') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.chief_executive_officer" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="numberOfEmployees">{{ $t('manual.numberOfEmployees') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.number_of_employees" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="organizationalStructure">{{ $t('manual.organizationalStructure') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.organizational_structure" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="certification">{{ $t('manual.certification') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.certification" class="form-control" />
                                </div>
                            </div>
                            <h5 class="my-5">{{ $t('manual.titleForm2') }}</h5>
                            <div class="form-group row">
                                <label class="col-sm-2" for="technicalSafety">{{ $t('manual.technicalSafety') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.technical_safety" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="organizationalSecurityManagement"
                                    >{{ $t('manual.organizationalSecurityManagement') }}
                                </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.organizational_security_management" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="physicalSecurityManagement">{{ $t('manual.physicalSecurityManagement') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.physical_security_management" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="humanSecurityManagement">{{ $t('manual.humanSecurityManagement') }} </label>
                                <div class="col-sm-10">
                                    <textarea rows="5" v-model="initForm.human_security_management" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2" for="to">{{ $t('manual.logo') }} </label>
                                <div class="col-sm-3">
                                    <UploadFileCommon
                                        :fileValues.sync="initForm.logo"
                                        :id="$t('manual.logo')"
                                        :typeUpload="'image'"
                                        :processUpload.sync="isUploadFile"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Footer>
                <div class="text-center flex-fill">
                    <button
                        v-if="checkPermission('master.edit')"
                        type="submit"
                        @click="handleSubmit"
                        :disabled="isUploadFile"
                        class="btn btn-common btn-success"
                    >
                        {{ $t('btn.save') }}
                    </button>
                </div>
            </Footer>
        </div>

        <div v-else>
            <div class="d-flex justify-content-center">
                <LoadingIcon />
            </div>
        </div>
    </Layout>
</template>
<style></style>
